import { render, staticRenderFns } from "./CoveragePagePeriodGoodwish.vue?vue&type=template&id=d2c6a1f0"
import script from "./CoveragePagePeriodGoodwish.vue?vue&type=script&lang=js"
export * from "./CoveragePagePeriodGoodwish.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports